export default "/images/framework/Fail.78c0ca03.svg?78c0ca03";